import * as React from 'react';

import { Spinner } from 'components/common';
import { Button } from 'components/bootstrap';
import { Col, Row, DataWell } from 'common/components/layout-styles';
import { useGetDecoratedEventProcedure } from 'security-app/hooks/useEventProceduresAPI';

import EventProcedureDetailsView from '../EventProcedureDetailsView';

type Props = {
  eventProcedureId: string;
  eventId?: string;
  canEdit?: boolean;
  onRemove?: () => void;
  onEdit?: () => void;
  row?: boolean;
};

function EventProcedureSummary({
  eventProcedureId,
  eventId = undefined,
  canEdit = false,
  onRemove = undefined,
  onEdit = undefined,
  row = false,
}: Props) {
  const { eventProcedure, loadingEventProcedure } = useGetDecoratedEventProcedure(eventProcedureId, eventId);

  const handleRemove = React.useCallback(() => onRemove?.(), [onRemove]);
  const handleEdit = React.useCallback(() => onEdit?.(), [onEdit]);

  if (loadingEventProcedure) return <Spinner text="Loading Event Procedure" />;

  return (
    <DataWell>
      <Col>
        <h2 style={{ whiteSpace: 'break-spaces' }}>{eventProcedure?.title || <i>No title set</i>}</h2>
        <EventProcedureDetailsView
          eventProcedure={eventProcedure}
          descriptionMaxHeight={row ? 400 : 250}
          row={row}
          eventId={eventId}
        />
        {canEdit && (
          <Row $justify="flex-end">
            <Button bsSize="sm" bsStyle="danger" onClick={handleRemove}>
              Remove
            </Button>
            <Button bsSize="sm" bsStyle="primary" onClick={handleEdit}>
              Edit Event Procedure
            </Button>
          </Row>
        )}
      </Col>
    </DataWell>
  );
}

export default EventProcedureSummary;
